export const routes = {
  root: "/",
  auth: {
    login: "/auth/login/",
    logout: "/auth/logout/",
    register: "/auth/register/",
    confirm: "/auth/confirm/",
    refreshToken: "/auth/refresh-token/",
    passwordChange: "/auth/password-change/",
    passwordReset: "/auth/password-reset/",
    passwordResetConfirm: "/auth/password-reset/confirm",
    profile: {
      get: "/auth/profile/",
      update: "/auth/profile-update/",
      uploadAvatar: "/auth/avatar/",
      sessionRevoke: "/auth/session-revoke/",
      enable2FA: "/auth/enable-2fa/",
      disable2FA: "/auth/disable-2fa/",
      verify2FA: "/auth/verify-2fa/",
      deleteAccount: "/auth/delete-account/",
      passwordChange: "/auth/password-change/",
    },
  },
  pages: {
    login: "/",
    signup: "/signup",
    resetPassword: "/reset-password",
    createNewPassword: "/create-new-password",
    loggedIn: "/loggedin",
    profile: "/profile",
  },
} as const;

export type Routes = typeof routes;

export type AuthRoutes = Routes["auth"];

export type PagesRoutes = Routes["pages"];
